import { c as _c } from "react/compiler-runtime";
import './help-me-choose-answers.scss';
import { parseAsString, useQueryState } from 'nuqs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SelectionCardsGroup } from '../../../molecules/selection-cards-group/selection-cards-group.tsx';
import disabilityImage from '../images/disability-help-me-choose.webp';
import greatestNeedImage from '../images/greatest-need-help-me-choose.webp';
import hivAidsImage from '../images/hiv-help-me-choose.webp';
import vulnerableImage from '../images/vulnerable-help-me-choose.webp';
import { createAnswers } from '../utils/answers.ts';
export const HelpMeChooseCause: React.FC<{
  setAnyCause: React.Dispatch<React.SetStateAction<boolean>>;
}> = t0 => {
  const $ = _c(15);
  const {
    setAnyCause
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["help-me"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const [causes, setCauses] = useQueryState("filters", parseAsString);
  let t2;
  if ($[1] !== causes) {
    t2 = causes ? [causes] : [];
    $[1] = causes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [controlledCauses, setControlledCauses] = useState(t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    const causeCategories = [{
      label: "hiv",
      value: "affectedHiv",
      imageUrl: hivAidsImage
    }, {
      label: "exploitation",
      value: "vulnerableExploitation",
      imageUrl: vulnerableImage
    }, {
      label: "disability",
      value: "hasDisabilities",
      imageUrl: disabilityImage
    }, {
      label: "anywhere",
      value: "anywhere",
      imageUrl: greatestNeedImage
    }];
    t3 = createAnswers("how", causeCategories);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const causeAnswers = t3;
  let t4;
  if ($[4] !== setAnyCause || $[5] !== setCauses) {
    t4 = nextValues => {
      const value = nextValues && nextValues.length > 0 ? nextValues[0] : null;
      const isChecked = !!value;
      if (value === "anywhere") {
        setAnyCause(isChecked);
        setCauses(null);
      } else {
        setCauses(isChecked ? value : null);
        setAnyCause(false);
      }
      setControlledCauses(isChecked ? [value] : []);
    };
    $[4] = setAnyCause;
    $[5] = setCauses;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleSelectionChange = t4;
  let t5;
  if ($[7] !== controlledCauses) {
    t5 = controlledCauses || [];
    $[7] = controlledCauses;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("howAnswers.groupLabel");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleSelectionChange || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center"><SelectionCardsGroup cards={causeAnswers} selectionMode="single" value={t5} label={t6} onChange={handleSelectionChange} /></div>;
    $[11] = handleSelectionChange;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};